import React, {Fragment} from 'react';
import {UI, Popup, Collaboration, Lists} from 'components';
import {size, useNamedSelector} from 'helpers';
import {deleteList} from "store/lists";

export function Card({ id, context, Status = Collaboration.CardStatus, ActionMenu = Popup.Menu.Handle, ...props }) {
  const { Card } = UI;
  const details = useNamedSelector('lists.details', { id: id, context: 'lists' });
  const list = details.list;
  const settings = useNamedSelector('lists.settings');
  const items = (settings && (settings.filter === 'active'))
    ? details.items.filter(item => item.status !== 'Completed') || []
    : details.items || [];

  return (
    <Card navLink={`/lists/${list.id}/`} id={list.id} {...props}>
      <Status selector="lists.details" id={id} />
      <ActionMenu Menu={Menu} list={list} id={id} editable={details.editable} />
      <Card.Body>
        {list.id && <Card.Text color={list.color}>{list.name}</Card.Text>}
        <Fragment>
          { size(items) > 0 &&
            <Lists.ListItemsChecklist items={items} />
          }
        </Fragment>
      </Card.Body>
    </Card>
  );
}

function Menu({ list }) {
  return (
    <Fragment>
      <Popup.Menu.Item icon="pencil" to={`/lists/${ list.id }/`}>Edit</Popup.Menu.Item>
      <Popup.Menu.DeleteItem onConfirm={() => deleteList(list.id)}>Delete</Popup.Menu.DeleteItem>
    </Fragment>
  );
}
